'use client'

// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

// lib files
import { confirmedSessionCacheAtom, profileConfirmationAtom, userProfile } from '@/lib/atoms/profile';
import { resolveProfile } from '@/lib/identity/resolution';
import useInterval from '@/lib/hooks/useInterval';

interface NetworkProfileProps {
  pollRate: number;
}

/**
 * Keeps the client's view of who is signed in in step with the server.
 *
 * Revalidation runs only while a profile is held, so signed-out visitors are not
 * polled.
 */
const NetworkProfile = ({ pollRate }: NetworkProfileProps) => {
  const profile = useAtomValue(userProfile)
  const setProfile = useSetAtom(userProfile)
  const setConfirmation = useSetAtom(profileConfirmationAtom)
  const confirmedSession = useAtomValue(confirmedSessionCacheAtom)
  const setConfirmedSession = useSetAtom(confirmedSessionCacheAtom)
  const maxConfirmedAgeMs = pollRate * 60 * 1000

  // Once per mount; resolveProfile decides what the session says.
  useEffect(() => {
    resolveProfile({ profile, setProfile, setConfirmation, confirmedSession, setConfirmedSession, maxConfirmedAgeMs })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useInterval(
    () => resolveProfile({ profile, setProfile, setConfirmation, confirmedSession, setConfirmedSession, maxConfirmedAgeMs, isRevalidation: true }),
    profile ? maxConfirmedAgeMs : null,
  )

  return null;
}

export default NetworkProfile;
